import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { cloneDeep, isEqual, some } from 'lodash';
import { Options } from 'ng5-slider';
import { NGXLogger } from 'ngx-logger';
import { Address, AddressMapComponent, AddressService, Costmodel, CrudService, Customer, CustomerType, Delivery, DeliveryService, DeliveryStatus, DELTA, Depo, DialogService, Dispatch, DispatchSegment, DispatchService, DispatchStatus, ENDICON, haversineDistance, Icons, isValidDate, JobCategory, LocationService, MAP_MARGINBOTTOM, MAP_MAXPERC, MapComponent, MapMarker, MapPosition, MessageService, MINHEIGHT, ModalWrapperComponent, ORVRoute, OrvRoutePrefix, Page, Pod, POLY_OPACITY_CURRENT, POLY_OPACITY_OPT, POLY_OPACITY_ORIG, POLY_OPACITY_REALTIME, POLY_WEIGHT_CURRENT, POLY_WEIGHT_OPT, POLY_WEIGHT_ORIG, POLY_WEIGHT_REALTIME, SaDatePipe, Search, User, Vehicle, VehicleMapItem, VehicleService } from 'orv-ui-base-lib';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AclService } from '../../data/acl.service';
import { DraggableCardsComponent } from '../draggable-cards/draggable-cards.component';
import { AddTaskComponent } from '../route-planner/add-task/add-task.component';
import { KpitableComponent } from '../route-planner/kpitable/kpitable.component';

@Component({
	selector: 'app-route-manager-responsive',
	templateUrl: './route-manager-responsive.component.html',
	styleUrls: ['./route-manager-responsive.component.scss']
})
export class RouteManagerResponsiveComponent implements OnInit, OnDestroy, AfterViewInit {

	mapmode: string;
	datePipe = new SaDatePipe('en');
	CURRENTPREFIX = OrvRoutePrefix.CURRENTPREFIX;
	OPTIMIZEDPREFIX = OrvRoutePrefix.OPTIMIZEDPREFIX;
	REALTIMEPREFIX = OrvRoutePrefix.REALTIMEPREFIX;
	ORIGINALPREFIX = OrvRoutePrefix.ORIGINALPREFIX;

	DeliveryStatus = DeliveryStatus;

	lastClick: number;

	CURRENTCOLOR = '#fc1616';

	OPTIMIZEDCOLOR = '#9a4fbc';

	ORIGINALCOLOR = '#707577';

	REALTIMECOLOR = '#000';

	value: number = 100;
	options: Options = {
		floor: 0,
		ceil: 200
	};

	inprogressDelivery: number;
	returnpresent: boolean;
	loadingrealtime: boolean;
	sortenabled: boolean;

	showGraph: boolean = false;
	graphHeight: number = 0;
	nextclicked: boolean = false;


	@Input()
	editorder: boolean = true;

	@Input() responsive: boolean;
	@Input() narrowspace: boolean = false;

	@Input()
	summary: boolean;
	startmarker: MapMarker;
	endmarker: MapMarker;
	poddelivery: Delivery;
	phisicalstartmarker: MapMarker;
	phisicalendmarker: MapMarker;
	phisicalstartdistance: any;

	@Input()
	set extraheight(value: number) {
		this.logger.log('set extraheight');
		if (value !== undefined && value !== this.graphHeight) {
			this.graphHeight = value;
			this.adjustContainer(value);

		}
	}




	@Input()
	route: ORVRoute;

	@Input() dispatchCreation: boolean = false;


	@Input()
	set dispatch(value: Dispatch) {

		if (this._dispatch !== value) {
			this._dispatch = value;
			this.initDispatch();
		}

	}

	get dispatch(): Dispatch {
		return this._dispatch;
	}

	_dispatch: Dispatch;

	optimizedRoute: ORVRoute;
	notoptimizedRoute: ORVRoute;

	@Input()
	editable: boolean;

	customer: Customer;
	_loading: boolean = false;

	get loading() {
		return this._loading;
	}

	set loading(value: boolean) {
		this._loading = value;
		if (value && this.onloading) {
			this.onloading.emit();
		} else if (!value && this.onready) {
			this.onready.emit();
		}
	}
	selectedCustomer: Customer;
	customerSearch: Search = new Search('customer');
	depoSearch: Search = new Search('depo');
	costmodelSearch: Search = new Search('costmodel');
	depoEntityClass: ClassType<Depo> = Depo;
	customerEntityClass: ClassType<Delivery> = Delivery;
	costmodelEntityClass: ClassType<Costmodel> = Costmodel;

	vehicleclass: Costmodel;


	@ViewChild('map') map: MapComponent;
	@ViewChild('container') container: ElementRef;
	// @ViewChild('topdata') topdata: ElementRef;
	@ViewChild('leftpanel') leftpanel: ElementRef;
	@ViewChild('scrollable') scrollable: ElementRef;
	@ViewChild('deliverieslist') deliveriesList: DraggableCardsComponent;


	optimize: boolean;
	marker: any;

	optimizedPolylines: DispatchSegment[];
	polylines: DispatchSegment[];
	originalPolylines: DispatchSegment[];
	realtimePolylines: DispatchSegment[];
	dispatchPolyline: MapPosition[];
	dispatchlocations: MapPosition[] = []; // incremental locations
	dispatchstart: number;
	dispatchstop: number;


	showoptimizedroute: boolean;
	showcurrentroute: boolean;
	showrealtimeroute: boolean;
	showoriginalroute: boolean;
	showpanel: boolean = false;
	showmap: boolean = true;
	showcalcsaveorder: boolean = false;
	showmappane: boolean = false;
	routepanelacl: boolean = false;
	showresetorder: boolean = false;
	showapplyoptimized: boolean = false;
	showapplyoptimizedandsave: boolean = false;

	showpolylinebackup: any;


	moreinfo: boolean;
	moreinfomarker: any;
	showslider: boolean;
	sliderstartvalue: number;
	sliderstopvalue: number;
	slideroptions: Options;
	realtimeupdate: boolean;

	returnvisible: any;
	originaladded: boolean;
	simulating: boolean;
	optimizedadded: boolean;

	returnsegment: any = {};
	segmentsVisibility: any = {};
	segmentsPresence: any = {};
	slidermaxvalue: number;

	rangeloaded: boolean;

	tast: boolean = false;

	timeStruct: any;

	pods: Pod[];


	@Output() onloading: EventEmitter<any> = new EventEmitter<any>();
	@Output() onready: EventEmitter<any> = new EventEmitter<any>();

	selectedDriver: User;
	selectedVehicle: Vehicle;
	vehicleEntityClass: ClassType<Vehicle> = Vehicle;
	driverEntityClass: ClassType<User> = User;
	driverEntitySearch: Search = new Search('orvuser');
	vehicleEntitySearch: Search = new Search('vehicle');

	isCommercial: boolean;

	deliverymode: string;
	tasksort: string = 'deliveryorder';

	get selectedStartDepo() {
		return this.route.depo;
	}
	set selectedStartDepo(value) {
		this.route.depo = value;
	}
	get selectedStopDepo() {
		return this.route.returndepo;
	}
	set selectedStopDepo(value) {
		this.route.returndepo = value;
	}

	constructor(private logger: NGXLogger, private customerService: CrudService<Customer>,
		private modalService: NgbModal,
		private addressService: AddressService,
		private vehicleService: VehicleService,
		private dispatchService: DispatchService,
		private podService: CrudService<Pod>,
		public aclService: AclService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private cdr: ChangeDetectorRef,
		private _el: ElementRef,
		private location: Location,

		private router: Router,
		private locationService: LocationService,
		private dialogService: DialogService,
		private deliveryService: DeliveryService) {
		this.customerSearch.addSimpleFilter('ctype', CustomerType.delivery);
		this.costmodelSearch.addNotEqualFilter('literkm', 0);
		this.route = new ORVRoute();
		this.returnvisible = {};

		this.returnvisible[this.OPTIMIZEDPREFIX] = true;
		this.returnvisible[this.CURRENTPREFIX] = true;
		this.returnvisible[this.ORIGINALPREFIX] = true;
		this.isCommercial = environment.commercial;

	}

	ngOnInit() {
		this.setAclFeatures();

		this.driverEntitySearch.addSimpleFilter('jobcategory', JobCategory.DRIVER, 1);

		if (this.extraheight) {
			this.showGraph = true;
		} else {
			this.showGraph = false;
		}

		if (!this.route.departuredate) {
			this.route.departuredate = new Date().getTime();
		}


		this.lastClick = new Date().getTime();

		console.log('ROUTE', this.route);

	}

	ngOnDestroy(): void {
	}

	ngAfterViewInit() {

		if (!this.extraheight) {
			this.adjustMap();
		}

	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.adjustMap();
	}

	toggleShowmap() {
		this.showmap = !this.showmap;
		if (!this.showmap) {
			this.showpanel = true;
		}
	}

	toggleShowpanel() {
		this.showpanel = !this.showpanel;
		if (!this.showpanel) {
			this.showmap = true;
		}

		if (this.showpanel) {
			this.adjustContainer(0);
		}
	}

	adjustMap() {
		console.log('adjustMap');
		if (this.map && this.container) {
			const h = this.container.nativeElement.offsetHeight;
			/*	if (this.topdata && this.topdata.nativeElement) {
					h = h - this.topdata.nativeElement.offsetHeight - 25;
	
				}*/

			let maph = h - MAP_MARGINBOTTOM;
			const mapperc = maph / window.screen.height;

			if (mapperc > MAP_MAXPERC) {
				maph = window.screen.height * MAP_MAXPERC;
			}

			this.map.setSize(undefined, maph);
		}
	}

	adjustContainer(extraheight: number) {
		this.logger.log('adjustContainer');
		if (window.innerHeight > MINHEIGHT) {
			if (!this.narrowspace) {
				if (this.container) {
					this.adjustArea(this.container, extraheight);
				}
				if (this.leftpanel) {
					this.adjustArea(this.leftpanel, extraheight);
				}
			}

			if (this.scrollable) {
				// this.adjustArea(this.scrollable, extraheight);
			}

			this.adjustMap();
		}
	}

	next() {

		if (!this.dispatch) {

			if (this.route.departuredate < new Date().getTime()) {
				const messages = this.translateService.instant(['labels.future-departuretime', 'labels.error']);
				this.messageService.sendWarn(messages['labels.future-departuretime'], messages['labels.dispatch']);
				return;
			}


			this.nextclicked = true;
		}




	}

	adjustArea(area: ElementRef, extraheight: number) {
		if (!this.responsive) {
			let h = area.nativeElement.offsetHeight;
			if (extraheight) {
				h = h - extraheight - 50;
				area.nativeElement.style.height = h + 'px';
			} else {
				area.nativeElement.style.height = '';
			}
		}
	}

	initDispatch() {
		this.logger.log('initDispatch');

		if (this.map) {
			this.map.removePolylines();
		}
		if (this.dispatch && !this.dispatch.importissue) {
			this.route = new ORVRoute(this.dispatch);
		}

		this.loadPods().subscribe(data => {
			this.setupDispatch();
		});


	}



	setupDispatch() {
		this.sortenabled = this.dispatch.isStatusIdle;



		// if (this.route.waypoints && this.route.waypoints.length && this.route.valid) {

		if (this.route.waypoints && this.route.waypoints.length) {
			this.loading = true;
			this.optimize = true;
			this.calculate(false);

		}

		if (this.dispatch && (this.dispatch.status === DispatchStatus.ONRIDE || this.dispatch.status === DispatchStatus.COMPLETED)) {
			this.dispatchPolyline = [];
			this.dispatchstart = 0;
			this.dispatchstop = DELTA;
			this.initSlider();
		}

		if (this.dispatchCreation) {
			if (this.dispatch && this.dispatch.vehicle) {
				this.selectedVehicle = this.dispatch.vehicle;
				this.route.vehicleid = this.dispatch.vehicle.id;
			}
			if (this.dispatch && this.dispatch.driver) {
				this.selectedDriver = this.dispatch.driver;
				this.route.driverid = this.dispatch.driver.id;
			}
			if (this.dispatch && this.dispatch.draftstartingdepo) {
				this.route.depo = this.dispatch.draftstartingdepo;
				this.route.fromlocid = this.dispatch.draftstartingdepo.id;
			}
			if (this.dispatch && this.dispatch.draftstopdepo) {
				this.route.returndepo = this.dispatch.draftstopdepo;
				this.route.tolocid = this.dispatch.draftstopdepo.id;
			}
			if (this.dispatch && this.dispatch.lmsid) {
				this.route.customerref = this.dispatch.lmsid;
			}
			if (this.dispatch && !isEqual(this.dispatch.draftstopdepo, this.dispatch.draftstartingdepo)) {
				this.route.nocomeback = true;
			}
		}
	}
	loadPods(): Observable<any> {
		const search = new Search('pod');
		search.addInFilter('did', this.dispatch.deliveries.map(d => d.id));
		return this.podService.searchEntities(Pod, 'pod', search, new Page(100)).pipe(map(result => {
			this.pods = result;
			return of(true);
		}), catchError((error: any) => {
			this.messageService.sendError(error && error.error ? error.error.msg : 'An error occurred');
			return of(false);
		}));
	}

	initSlider() {
		this.showslider = true;
		this.sliderstartvalue = this.dispatch.startdate ? this.dispatch.startdate : 0;
		this.slidermaxvalue = this.dispatch.stopdate ? this.dispatch.stopdate : new Date().getTime();
		this.sliderstopvalue = this.dispatch.stopdate ? this.dispatch.stopdate : new Date().getTime();

	}



	// called when time range change on "gantt" slider
	updateTimeRange(start: Date, stop: Date, fullrange?: boolean) {
		if (isValidDate(start) && isValidDate(stop) && (start.getTime() !== this.sliderstartvalue || stop.getTime() !== this.sliderstopvalue)) {
			this.sliderstartvalue = start.getTime();
			this.sliderstopvalue = stop.getTime();
			this.cdr.detectChanges();
			if (this.rangeloaded) {
				this.updateLocations(undefined, fullrange);
			}
			this.rangeloaded = true; // I need this to avoid double load at the beginning (check doesn't work because range is initialized with diapatch time and not delivery time)
		}

	}



	// update real time locations based on current selection on slider
	updateLocations(event: any, fullrange?: boolean) {
		if (this.dispatch) {
			if (!this.showpolylinebackup) {
				this.showpolylinebackup = {};
				this.showpolylinebackup.showcurrentroute = this.showcurrentroute;
				this.showpolylinebackup.showoptimizedroute = this.showoptimizedroute;
				this.showpolylinebackup.showoriginalroute = this.showoriginalroute;
				this.showpolylinebackup.showrealtimeroute = this.showoriginalroute;
				this.showpolylinebackup.realtimeupdate = this.showoriginalroute;
			}
			this.loadingrealtime = true;
			this.cdr.detectChanges();
			this.removePolylines(this.realtimePolylines, this.REALTIMEPREFIX);
			this.segmentsVisibility = {};
			this.segmentsPresence = {};
			this.returnvisible = {};

			if (!fullrange) {
				this.togglePolylines(this.originalPolylines, false, this.ORIGINALPREFIX);
				this.togglePolylines(this.optimizedPolylines, false, this.OPTIMIZEDPREFIX);
				this.togglePolylines(this.polylines, fullrange, this.CURRENTPREFIX);
				this.showcurrentroute = false;
				this.showoptimizedroute = false;
				this.showoriginalroute = false;
				this.realtimeupdate = false;
				this.showrealtimeroute = false;
			} else {
				this.showcurrentroute = this.showpolylinebackup.showcurrentroute;
				this.showoptimizedroute = this.showpolylinebackup.showoptimizedroute;
				this.showoriginalroute = this.showpolylinebackup.showoriginalroute;
				this.realtimeupdate = this.showpolylinebackup.realtimeupdate;
				this.showrealtimeroute = this.showpolylinebackup.showrealtimeroute;
				this.togglePolylines(this.originalPolylines, this.showoriginalroute, this.ORIGINALPREFIX);
				this.togglePolylines(this.optimizedPolylines, this.showoptimizedroute, this.OPTIMIZEDPREFIX);
				this.togglePolylines(this.polylines, this.showcurrentroute, this.CURRENTPREFIX);

			}

			this.loadLocationsInTimeRange(this.sliderstartvalue, this.sliderstopvalue);

		}
	}

	// load real time locations based on time range selection 
	loadLocationsInTimeRange(start, stop) {
		if (this.dispatch && start && stop) {
			this.dispatchService.getRealSegments(this.dispatch.id, start, stop).subscribe(locations => {
				this.realtimePolylines = locations;
				this.addPolylines(this.realtimePolylines, this.REALTIMECOLOR, this.REALTIMEPREFIX, POLY_WEIGHT_REALTIME, POLY_OPACITY_REALTIME);
				this.showrealtimeroute = true;
				this.route.createCurrentMap(locations);
				if (locations && locations.length === this.route.waypoints.length + 1) {
					this.returnvisible[this.REALTIMEPREFIX] = true; // this is visible only if segments number equals delivery number + 1
					this.returnpresent = true;
				} else if (locations && locations.length) { // else the last segment belongs to the "in progress" delivery
					this.returnvisible[this.REALTIMEPREFIX] = false;
					this.returnpresent = false;
					this.segmentsVisibility.inprogress = true;
					this.inprogressDelivery = locations[locations.length - 1].fromdelid;
				}
				this.loading = false;
				this.loadingrealtime = false;
				this.cdr.detectChanges();

			}, error => {
				this.messageService.sendError(error);
				this.loading = false;
				this.loadingrealtime = false;
			});
		}
		if (this.dispatch.isStatusOnRide) {
			this.loadVehiclePosition();
		}

	}

	loadVehiclePosition() {
		if (this.dispatch && this.dispatch.vehicle && this.dispatch.vehicle.fleetcode) {
			this.logger.log('loadVehiclePosition');
			this.vehicleService.getMapById(this.dispatch.vehicle.id).subscribe(items => {
				if (items && items.length && this.map) {
					const v: VehicleMapItem = items[0];
					v.truckicon = true;
					this.map.addMarker(v);

				}
			});
		}
	}

	sortDeliveries(sortorder: string) {
		const markers = cloneDeep(this.map.markers);
		this.map.removeMarkers();
		let icon;
		let highlightedicon;
		this.logger.log('sortorder:' + sortorder);
		switch (sortorder) {
			case 'deliveryorder':
				this.sortenabled = this.dispatch.isStatusIdle;
				icon = 'assets/images/map/markers/marker_currentroute.svg';
				highlightedicon = 'assets/images/map/markers/marker_currentroute.svg';
				this.showoptimizedroute = false;
				this.showoriginalroute = false;
				this.showcurrentroute = true;
				break;
			case 'optimizedorder':
				this.sortenabled = false;
				icon = 'assets/images/map/markers/marker_optimisedroute.svg';
				highlightedicon = 'assets/images/map/markers/marker_optimisedroute.svg';
				this.showoptimizedroute = true;
				this.showoriginalroute = false;
				this.showcurrentroute = false;
				break;
			case 'lmsorder':
				this.sortenabled = false;
				icon = 'assets/images/map/markers/marker_originalroute.svg';
				highlightedicon = 'assets/images/map/markers/marker_originalroute.svg';
				this.showoptimizedroute = false;
				this.showoriginalroute = true;
				this.showcurrentroute = false;
				break;

		}
		if (markers) {
			markers.forEach(m => {
				if (m instanceof Delivery) {
					m.label = m[sortorder] + 1;
					m.icon = icon;
					m.highlightedicon = highlightedicon;
				}
			});
		}
		this.togglePolylines(
			this.optimizedPolylines,
			this.showoptimizedroute,
			this.OPTIMIZEDPREFIX
		);
		this.togglePolylines(
			this.originalPolylines,
			this.showoriginalroute,
			this.ORIGINALPREFIX
		);
		this.togglePolylines(
			this.polylines,
			this.showcurrentroute,
			this.CURRENTPREFIX
		);
		this.map.markers = markers;
		this.deliveriesList.sortItems(sortorder);
	}


	addStartStopMarkers(locations: MapPosition[]) {
		console.log('addStartStopMarkers');

		if (locations.length) {


			if (this.dispatch && this.dispatch.status !== DispatchStatus.ONRIDE && !this.route.comeback) { // not adding it if return to depot because they overlap
				const lastIndex = locations.length - 1;
				const icon = 'assets/images/map/pointer-end.svg';
				const endMarker: MapMarker = {
					id: 'end',
					lat: locations[lastIndex].lat,
					lng: locations[lastIndex].lng,
					icon
				};
				this.map.addMarker(endMarker, true);

			}
		}
	}


	dragStart(del: Delivery) {
		if (this.map && del) {
			this.map.highlightMarker(del, true);
			this.map.moveToLocation(del);
		}
	}

	dragEnd(del: Delivery) {
		if (this.map && del) {
			this.map.highlightMarker(del, false);
		}
	}


	dragCanceled(del: Delivery) {
		if (this.map && del) {
			this.map.highlightMarker(del, false);
		}
	}

	highlightDelivery(del: Delivery) {
		if (this.map) {
			this.map.closeAllInfoWindows();
			const m = this.route.waypoints.find((d: Delivery) => d.id === del.id);

			// FIXME some data is missing in dispatch deliveries list. Too risky to iterate the waypoints atm, don't have time to check everthing

			this.onMarkerClicked(m);
			this.map.moveToLocation(m);
		}
	}

	highlightStart() {

		if (this.map) {
			this.map.closeAllInfoWindows();
			this.onMarkerClicked(this.startmarker);
			this.map.moveToLocation(this.startmarker);
		}
	}

	highlightEnd() {
		if (this.map) {
			this.map.closeAllInfoWindows();
			this.onMarkerClicked(this.endmarker);
			this.map.moveToLocation(this.endmarker);
		}
	}


	toggleReturn(prefix: string, show: boolean) {
		if (this.map) {
			this.logger.log('togglePolyline', this.returnsegment[prefix], show);
			this.map.togglePolyline(prefix + this.returnsegment[prefix], show);
		}

	}

	toggleReturnCurrent(show?: boolean) {
		this.logger.log('toggleReturnCurrent');
		this.toggleReturn(this.CURRENTPREFIX, show);
		this.checkCurrentRouteVisibility(show);
	}

	toggleReturnOptimized(show?: boolean) {
		this.toggleReturn(this.OPTIMIZEDPREFIX, show);
		this.checkOptmizedRouteVisibility(show);
	}


	toggleReturnOriginal(show?: boolean) {
		this.toggleReturn(this.ORIGINALPREFIX, show);
		this.checkOriginalRouteVisibility(show);
	}

	toggleReturnRealtime(show?: boolean) {
		this.toggleReturn(this.REALTIMEPREFIX, show);
		this.checkRealtimeRouteVisibility(show);
	}

	toggleCurrentSegment(index: number, show?: boolean) {
		const to = (this.deliveriesList.items[index] as Delivery);
		const from = to.deliveryorder > 0 ? (this.deliveriesList.items.filter(d => (d as Delivery).deliveryorder === to.deliveryorder - 1)[0] as Delivery) : undefined;

		if (show === undefined) this.segmentsVisibility[to.id][this.CURRENTPREFIX] = !this.segmentsVisibility[to.id][this.CURRENTPREFIX];
		const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.CURRENTPREFIX];
		if (to && sh) {
			this.highlightDelivery(to);
		}
		this.checkCurrentRouteVisibility(sh);
		this.toggleSegment(from ? from.id : '', to.id, this.CURRENTPREFIX, sh);

	}

	toggleOptimizedSegment(index, show?: boolean) {
		if (!this.optimizedadded) {
			this.togglePolylines(this.optimizedPolylines, false, this.OPTIMIZEDPREFIX);
		}

		const to = (this.deliveriesList.items[index] as Delivery);
		const from = to.optimizedorder > 0 ? (this.deliveriesList.items.filter(d => (d as Delivery).optimizedorder === to.optimizedorder - 1)[0] as Delivery) : undefined;

		if (show === undefined) this.segmentsVisibility[to.id][this.OPTIMIZEDPREFIX] = !this.segmentsVisibility[to.id][this.OPTIMIZEDPREFIX];
		const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.OPTIMIZEDPREFIX];
		if (to && sh) {
			this.highlightDelivery(to);
		}
		this.checkCurrentRouteVisibility(sh);
		this.toggleSegment(from ? from.id : '', to.id, this.OPTIMIZEDPREFIX, sh);
	}

	toggleRealtimeSegment(to: Delivery, show?: boolean, inprogress?: boolean) {

		if (inprogress) {
			this.toggleReturn(this.REALTIMEPREFIX, show);

		} else {

			const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.REALTIMEPREFIX];

			/*if (to && sh) {
				this.highlightDelivery(to);
			}*/
			this.checkRealtimeRouteVisibility(sh);
			if (to && this.route && this.route.currentMap && this.route.currentMap[to.id]) {
				this.toggleSegment(this.route.currentMap[to.id].fromdelid, to.id, this.REALTIMEPREFIX, sh);
			}
		}
	}



	toggleOriginalSegment(index: number, show?: boolean) {

		if (!this.originaladded) {
			this.togglePolylines(this.originalPolylines, false, this.ORIGINALPREFIX);
		}
		const to = (this.deliveriesList.items[index] as Delivery);
		const from = to.lmsorder > 0 ? (this.deliveriesList.items.filter(d => (d as Delivery).lmsorder === to.lmsorder - 1)[0] as Delivery) : undefined;

		if (show === undefined) this.segmentsVisibility[to.id][this.ORIGINALPREFIX] = !this.segmentsVisibility[to.id][this.ORIGINALPREFIX];
		const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.ORIGINALPREFIX];
		if (to && sh) {
			this.highlightDelivery(to);
		}
		this.checkCurrentRouteVisibility(sh);
		this.toggleSegment(from ? from.id : '', to.id, this.ORIGINALPREFIX, sh);

	}

	toggleSegment(from: any, to: any, prefix: string, show?: boolean) {
		this.logger.log('toggleSegment', from, to);
		let id = '';
		let visible = true;

		if (from !== undefined && from !== null) {
			id = id + from;
		}


		if (to !== undefined && to !== null) {
			if (to !== '') {
				id = id + '-' + to;
			}
			visible = show;
		} else {
			id = id + '-' + from;
			visible = show;
		}



		if (this.map) {
			this.map.togglePolyline(prefix + id, visible);

		}
	}

	checkRealtimeRouteVisibility(show: boolean) {
		this.logger.log('checkRealtimeRouteVisibility', show);
		if (show && this.checkRouteVisibility(this.REALTIMEPREFIX) && this.returnvisible[this.REALTIMEPREFIX]) {
			this.showrealtimeroute = true;
		} else {
			this.showrealtimeroute = false;
		}
	}


	checkOptmizedRouteVisibility(show: boolean) {
		if (show && this.checkRouteVisibility(this.OPTIMIZEDPREFIX) && this.returnvisible[this.OPTIMIZEDPREFIX]) {
			this.showoptimizedroute = true;
		} else {
			this.showoptimizedroute = false;
		}
	}

	checkOriginalRouteVisibility(show: boolean) {
		if (show && this.checkRouteVisibility(this.ORIGINALPREFIX) && this.returnvisible[this.ORIGINALPREFIX]) {
			this.showoriginalroute = true;
		} else {
			this.showoriginalroute = false;
		}
	}
	checkCurrentRouteVisibility(show: boolean) {
		if (show && this.checkRouteVisibility(this.CURRENTPREFIX) && this.returnvisible[this.CURRENTPREFIX]) {
			this.showcurrentroute = true;
		} else {
			this.showcurrentroute = false;
		}
	}
	checkRouteVisibility(prefix: string) {
		this.logger.log('checkRouteVisibility');
		const visibility = this.segmentsVisibility;
		return !some(this.route.waypoints, function (el) {
			return !visibility[el.id][prefix];
		});
	}

	onMarkerClicked(event: any) {
		this.marker = event;
		if (event.pod) {
			this.poddelivery = this.dispatch.deliveries.find((d: Delivery) => d.id === event.pod.did);
		} else {
			this.poddelivery = undefined;
		}

		this.cdr.detectChanges();
		const html = this._el.nativeElement.querySelector('#infowindow').innerHTML;
		if (html) {
			this.map.openInfoWindow(this.marker, html);
			this.markerMoreInfo(this.marker);
		}

	}

	onMarkerHighlight(event: any) {

	}

	boundsChanged(event: any) {
	}


	addDepo(depo: Depo, old?: Depo) {
		if (depo) {
			depo.clickable = true;
			depo.infoWindow = false;
			this.map.addMarker(depo, true);
			this.route.startingfrom = depo.depcode;
			if (this.route.returndepo && this.route.returndepo.id !== this.selectedStartDepo.id) {
				this.map.removeMarker(this.selectedStartDepo, true);
			}
			if (this.route.comeback) {
				this.route.returndepo = this.route.depo;
				this.addReturnDepo(this.route.depo, this.route.returndepo);
			}
			if (this.route.returndepo && this.route.depo.id === this.route.returndepo.id) {
				this.route.comeback = true;
			}
		} else if (this.route.startingfrom) {
			this.map.addMarkerAtLatLng(this.route.startinglat, this.route.startinglng, this.route.startingfrom, 'startingpoint', Icons.STARTICON, true);
		}

		if (this.dispatch.physicalstartlat && this.dispatch.physicalstartlng) {
			const phisicalStart: MapMarker = {
				id: 'phisicalStart',
				lat: this.dispatch.physicalstartlat,
				lng: this.dispatch.physicalstartlng,
				icon: Icons.PHYSICALSTART,
				highlightedicon: Icons.PHYSICALSTART
			};

			this.map.addMarker(phisicalStart, true);
		}
		if (this.dispatch.stoplat && this.dispatch.stoplng) {
			const phisicalEnd: MapMarker = {
				id: 'phisicalEnd',
				lat: this.dispatch.stoplat,
				lng: this.dispatch.stoplng,
				icon: Icons.PHYSICALEND,
				highlightedicon: Icons.PHYSICALEND
			};

			this.map.addMarker(phisicalEnd, true);
		}


		if (this.map._markers.length === 1) {
			this.map.zoomToMarkers(null, 14, 14, false);
		} else {
			this.map.zoomToMarkers(null, null, null, true);
		}

	}


	addReturnDepo(depo: Depo, old?: Depo) {
		if (depo) {
			this.route.goingto = depo.depcode;
			this.route.endinglat = depo.lat;
			this.route.endinglng = depo.lng;
			if (this.route.depo.id !== depo.id) {
				depo.clickable = true;
				depo.infoWindow = false;
				depo.icon = ENDICON;
				this.map.addMarker(depo, true);
				this.route.comeback = false;
			} else {
				this.route.comeback = true;
			}
			if (old && this.route.depo && old.id !== this.route.depo.id) {
				this.map.removeMarker(old, true);
			}
		} else if (this.route.goingto && this.route.goingto !== this.route.startingfrom) {
			this.map.addMarkerAtLatLng(this.route.endinglat, this.route.endinglng, this.route.goingto, 'goingto', ENDICON, true);
		}

	}

	onTimeChange(time: any) {
		if (time && time.hour && time.minute >= 0 && this.route.departuredate) {
			const d = new Date(this.route.departuredate);
			d.setHours(time.hour);
			d.setMinutes(time.minute);
			this.route.departuredate = d.getTime();

			const date = new Date();


		}
	}

	setComeback(comeback: boolean) {
		if (comeback) {
			this.addReturnDepo(this.route.depo, this.route.returndepo);
			this.route.returndepo = this.route.depo;
		}
	}

	addDelivery(delivery: Customer) {
		if (delivery) {
			this.addressService.getAddressesByCid(delivery.id).subscribe((data: Address[]) => {
				if (data && data[0]) {
					const del = this.route.addDelivery(delivery, data[0]);
					this.optimize = true;

					this.map.addMarker(del, true);
				}
			}, ({ error }) => {
				this.messageService.sendError(error);
			});
		}
	}

	addTask() {

		const modal = this.modalService.open(ModalWrapperComponent, { centered: true, size: 'lg', backdrop: 'static' });
		modal.componentInstance.component = AddTaskComponent;
		modal.componentInstance.title = this.translateService.instant('labels.new-task');
		modal.componentInstance.inputs = { dispatchDate: this.route.departuredate };
		modal.componentInstance.outputs = {
			save: (d: Delivery) => {

				if (new Date().getTime() - this.lastClick <= 500) {
					return;
				}

				this.lastClick = new Date().getTime();

				this.addressService.getAddressesByCid(d.customer.id).subscribe((data: Address[]) => {
					if (data && data[0]) {
						const del = this.route.addDelivery(d.customer, data[0], undefined, d.mode);
						del.orderref = d.orderref;
						del.timedefinite = d.timedefinite ? 1 : 0;
						del.deliverby = d.deliverby;
						del.orderref = d.orderref;
						del.orderid = d.orderid;

						this.optimize = true;
						this.map.addMarker(del);
						this.map.zoomToMarkers(null, null, null, true);
						modal.close();
					} else {
						const messages = this.translateService.instant(['labels.customer-invalid-address', 'labels.error']);
						this.messageService.sendWarn(messages['labels.customer-invalid-address'], messages['labels.error']);

					}
				}, ({ error }) => {
					this.messageService.sendError(error);
				});
			},
			cancel: () => modal.dismiss()
		};
	}

	removeDelivery(event: any) {
		if (this.map && event.data && event.index !== undefined) {
			this.route.removeDelivery(event.index);
			this.map.removeMarker(event.data, true);
			this.optimize = true;
		}
	}

	orderChanged(event: any) {
		this.route.cansavecustom = true;
	}


	editAddress(delivery: Delivery) {

		const address = delivery.customer && delivery.customer.address ? delivery.customer.address : delivery.getAddress();

		const modal = this.modalService.open(ModalWrapperComponent, { centered: true, size: 'lg' });
		modal.componentInstance.component = AddressMapComponent;
		modal.componentInstance.title = this.translateService.instant(address.id || address.tmp ? 'labels.edit-address' : 'labels.new-address');
		modal.componentInstance.inputs = { address: address };
		modal.componentInstance.outputs = {
			save: (a: Address) => {
				modal.close();
				if (a && a.geocoding) {
					this.deliveryService.updateAddress(delivery.id, a.geocoding).subscribe((data: Delivery) => {
						const messages = this.translateService.instant(['labels.address-save-success', 'labels.customer']);
						this.messageService.sendSuccess(messages['labels.address-save-success'], messages['labels.customer']);
						delivery.updateGeocoding(data);
						this.route.cansavecustom = true;
					}, ({ error }) => {
						this.messageService.sendError(error, this.translateService.instant('labels.customer'));
					});
				}
			},
			cancel: () => modal.dismiss()
		};
	}

	calculate(simulating: boolean) {
		this.loading = true;
		this.logger.log('calculate');
		this.simulating = simulating;
		if (this.map) {
			this.map.closeAllInfoWindows();
		}
		this.applyInputOrder();
		// this.route.setSortIndex();
		this.route.optimize = false;

		if (this.vehicleclass) {
			this.route.vehicleclass = this.vehicleclass.vclass;
		}


		this.calculateOptimize().pipe(concatMap(optimized =>
			this.calculateNotOptimize())).subscribe(notoptimized => {
				this.setResults();
				this.loading = false;
			}, error => {
				this.messageService.sendError(error, error.code);
				this.setResults();
				this.loading = false;
				this.simulating = false;
			});



	}


	setResults() {
		this.route.setWaypointsData(this.optimizedRoute, this.notoptimizedRoute);
		this.route.waypoints.forEach(w => {
			const d = this.dispatch.deliveries.filter(del => del.id === w.id)[0];
			w.optimizedorder = d.optimizedorder;
		});

		this.updateMarkers(this.route.waypoints);
		this.setupZoom();
		if (this.dispatch && (this.dispatch.status === DispatchStatus.ONRIDE || this.dispatch.status === DispatchStatus.COMPLETED)) {
			this.loadLocationsInTimeRange(this.sliderstartvalue, this.sliderstopvalue);
		} else {
			this.loading = false;
		}
		if (this.isCommercial && !this.dispatch.isStatusOnRide && this.route.valid) {
			// this.openKpitable();
		}


	}

	openKpitable() {
		const modal = this.modalService.open(KpitableComponent, { centered: true, size: 'lg' });
		modal.componentInstance.optimized = this.optimizedRoute;
		modal.componentInstance.notoptimized = this.notoptimizedRoute;
		modal.componentInstance.showCloseButton = true;
		if (this.dispatch) {
			modal.componentInstance.travelled = this.dispatch;
		}






	}


	calculateNotOptimize(): Observable<any> {
		this.logger.log('calculateNOTOptimize');

		if ((this.dispatch && this.dispatch.routing !== 'optimal') || this.simulating) {
			this.removePolylines(this.polylines, this.CURRENTPREFIX);
		}
		if (this.simulating) {
			this.route.customize = true;
		} else {
			this.route.customize = false;
		}
		return this.dispatchService.planRoute(this.route).map(data => {
			if (data) {
				this.notoptimizedRoute = data;
				if (!this.optimize && data) {
					this.route.waypoints = data.waypoints;
					const prefix = this.OPTIMIZEDPREFIX;

				}
				this.route.cansavecustom = false;
				this.optimize = false; // turn off optimze. turn on only if deliveries are added. no need to optimize if other data changes
				if (this.simulating) {
					this.polylines = data.deliveries;
				} else if (this.dispatch && this.dispatch.routing === 'lms') {
					this.polylines = data.deliveries;
					this.originalPolylines = data.deliveries;
				} else if (this.dispatch && this.dispatch.routing === 'custom') {
					this.polylines = data.customdeliveries;
					this.originalPolylines = data.deliveries;
				} else if (this.dispatch && this.dispatch.routing === 'optimal') {
					this.originalPolylines = data.deliveries;
				}
				this.showoriginalroute = true;
				this.togglePolylines(this.originalPolylines, true, this.ORIGINALPREFIX);

				if (this.summary) {
					this.showoriginalroute = false;
					this.togglePolylines(this.originalPolylines, false, this.ORIGINALPREFIX);
				}


				if ((this.dispatch && this.dispatch.routing !== 'optimal') || this.simulating) {

					this.showcurrentroute = true;
					this.logger.log('add current Polylines ');
					this.addPolylines(this.polylines, this.CURRENTCOLOR, this.CURRENTPREFIX, POLY_WEIGHT_CURRENT, POLY_OPACITY_CURRENT);
					if (this.summary) {
						this.showcurrentroute = false;
						this.togglePolylines(this.polylines, false, this.CURRENTPREFIX);
					}
				}
			}
			return data;
		}, error => {
			// TODO
			this.logger.log(error);
		});

	}


	calculateOptimize(): Observable<any> {
		this.logger.log('calculateOptimize');
		if ((this.dispatch && this.dispatch.routing === 'optimal') || this.simulating) {
			this.removePolylines(this.polylines, this.CURRENTPREFIX);
		}
		if (!this.optimize) {
			if (!this.summary) {
				this.showoptimizedroute = true;
				this.togglePolylines(this.optimizedPolylines, true, this.OPTIMIZEDPREFIX);

				return Observable.of(true);
			}
		} else {
			this.removePolylines(this.optimizedPolylines, this.OPTIMIZEDPREFIX);
			const route = cloneDeep(this.route);
			route.optimize = true;
			return this.dispatchService.planRoute(route).map(data => {
				if (data) {
					this.optimizedRoute = data;
					this.route.waypoints = data.waypoints;
					if (!this.summary)
						this.showoptimizedroute = true;


					if (this.simulating || this.dispatch.routing === 'lms' || this.dispatch.routing === 'custom') {
						this.optimizedPolylines = data.deliveries;
						if (!this.summary) {
							this.addPolylines(this.optimizedPolylines, this.OPTIMIZEDCOLOR, this.OPTIMIZEDPREFIX, POLY_WEIGHT_OPT, POLY_OPACITY_OPT);
							this.optimizedadded = true;
						}
					} else if (this.dispatch.routing === 'optimal') {
						this.polylines = cloneDeep(data.deliveries);
						this.optimizedPolylines = data.deliveries;
						if (!this.summary) {
							this.showoptimizedroute = false;
							this.optimizedadded = false;
							this.returnvisible[this.OPTIMIZEDPREFIX] = false;
							this.addPolylines(this.polylines, this.CURRENTCOLOR, this.CURRENTPREFIX, POLY_WEIGHT_CURRENT, POLY_OPACITY_CURRENT);
						}
					}


				}
				return data;
			}, error => {
				this.messageService.sendError(error);

				this.logger.log(error);
			});
		}
	}

	applyCustom() {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-routeplanner-custom'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {

			if (result) {
				this.loading = true;
				/* this.applyInputOrder();
				this.route.setSortIndex();
				this.dispatch.setSortIndex(this.route.waypoints);*/
				this.dispatchService.applyCustom(this.dispatch).subscribe(r => {
					this.dispatch = r;
					// this.initDispatch();
					this.messageService.sendSuccess(this.translateService.instant('labels.success-routeplanner-custom'));
					const urlTree = this.router.createUrlTree([`/dispatch/dispatches/${this.dispatch.id}/1`], {
						queryParamsHandling: 'merge',
						preserveFragment: true,
					});
					this.location.go(urlTree.toString());
					window.location.reload();
				}, error => {
					this.messageService.sendError(error);
					this.loading = false;

				});
			}
		});
	}


	applyOptimized() {

		// this.logger.log('applyOptimized');
		if (this.dispatch && this.dispatch.status === DispatchStatus.IDLE) {
			console.log('here');
			this.dialogService.openConfirmModal({
				message: this.translateService.instant('labels.warning-routeplanner-optimized'),
				hasIcon: true,
				type: 'warning'
			}).then(result => {
				if (result) {
					this.dispatchService.applyOptimized(this.dispatch).subscribe(r => {
						r.deliveries.forEach(d => {
							d.lmsorder = d.optimizedorder;
						});
						this.messageService.sendSuccess(this.translateService.instant('labels.success-routeplanner-optimized'));
						const urlTree = this.router.createUrlTree([`/dispatch/dispatches/${this.dispatch.id}/1`], {
							queryParamsHandling: 'merge',
							preserveFragment: true,
						});
						this.location.go(urlTree.toString());
						window.location.reload();
					}, error => {
						this.messageService.sendError(error);
					});
				}
			});
		} else if (!this.dispatch) {
			this.route.applyOptimized();

			if (this.map) {
				this.map.closeAllInfoWindows();
			}
			this.applyInputOrder();
			this.route.setSortIndex();
			this.route.optimize = false;


			this.route.setWaypointsData(this.optimizedRoute, this.notoptimizedRoute);
			this.updateMarkers(this.route.waypoints);
			if (this.dispatch && (this.dispatch.status === DispatchStatus.ONRIDE || this.dispatch.status === DispatchStatus.COMPLETED)) {
				this.loadLocationsInTimeRange(this.sliderstartvalue, this.sliderstopvalue);
			} else {
				this.loading = false;
			}
			// this.calculate(true);

		}
	}

	applyInputOrder() {
		if (this.editorder) {
			this.route.applyInputOrder();
			this.editorder = false;
			this.route.cansavecustom = true;
		}
	}

	// reset() {
	//   if (this.dispatch && this.dispatch.status === DispatchStatus.IDLE) {
	//     this.dialogService.openConfirmModal({
	//       message: this.translateService.instant('labels.warning-routeplanner-reset'),
	//       hasIcon: true,
	//       type: 'warning'
	//     }).then(result => {
	//       if (result) {
	//         this.initDispatch();
	//       }
	//     });
	//   }
	// }


	reset(routePlanningForm: NgForm) {

		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-reset-dispatch'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				if (this.dispatchCreation) {
					this.nextclicked = false;
					this.route.waypoints = [];
					routePlanningForm.resetForm();

					this.map.resetMap();
					this.route.departuredate = new Date().getTime();
				} else {
					this.initDispatch();
				}
			}
		});





	}




	toggleRealTimePolyline(show: boolean) {

		this.togglePolylines(this.realtimePolylines, show, this.REALTIMEPREFIX);
	}

	togglePolylines(polilynes: DispatchSegment[], show: boolean, prefix: string) {

		if (prefix === this.ORIGINALPREFIX && !this.originaladded && show) {
			this.originaladded = true;
			this.addPolylines(this.originalPolylines, this.ORIGINALCOLOR, this.ORIGINALPREFIX, POLY_WEIGHT_ORIG, POLY_OPACITY_ORIG); // I add them 'cause it's the first time
		} else if (prefix === this.OPTIMIZEDPREFIX && !this.optimizedadded && show) {
			this.optimizedadded = true;
			this.addPolylines(this.optimizedPolylines, this.OPTIMIZEDCOLOR, this.OPTIMIZEDPREFIX, POLY_WEIGHT_OPT, POLY_OPACITY_OPT); // I add them 'cause it's the first time

		} else if (polilynes && this.map) {
			for (let index = 0; index < polilynes.length; index++) {
				polilynes[index].decodePolyline();

				if (polilynes[index].todelid !== undefined) {
					if (this.segmentsVisibility[polilynes[index].todelid] === undefined) {
						this.segmentsVisibility[polilynes[index].todelid] = {};
					}
					this.segmentsVisibility[polilynes[index].todelid][prefix] = show;
				}
				this.returnvisible[prefix] = show;
				this.map.togglePolyline(prefix + polilynes[index].polylineid, show);
			}
		}
	}

	updateMarkers(waypoints: Delivery[]) {
		this.map.markers = waypoints.filter(item => item.lat && item.lng);
		this.map.markers = this.map.markers.concat(this.pods.map(p => {
			const delivery: Delivery = this.dispatch.deliveries.find((d: Delivery) => d.id === p.did);

			const markerPod = {
				id: p.id,
				lng: p.lng,
				lat: p.lat,
				infoWindow: true,
				clickable: true,
				pod: p,
				label: delivery.label,
				icon: 'assets/images/map/markers/marker_pod.svg'
			};
			return markerPod;
		}));
		// adding skip deliveries
		this.map.markers = this.map.markers.concat(this.dispatch.deliveries.filter(d => d.skiplng && d.skiplng).map(delivery => {
			const markerSkip = {
				id: delivery.id + 10000, // fake id for skipped delivery
				lng: delivery.skiplng,
				lat: delivery.skiplat,
				infoWindow: true,
				clickable: true,
				label: delivery.label,
				icon: 'assets/images/map/markers/marker_canceled.svg'
			};
			return markerSkip;
		}));

		if (this.route.depo) {
			console.log('aggiungo marker start', this.route.returndepo);
			this.startmarker = { ...this.route.depo, id: 'startmarker', icon: Icons.STARTICON, infoWindow: true, clickable: true };
			this.map.addMarker(this.startmarker, true);

			// this.addDepo(null);
		}

		if (this.route.returndepo && !this.route.comeback) {
			this.endmarker = { ...this.route.returndepo, id: 'endmarker', icon: Icons.ENDICON, infoWindow: true, clickable: true };
			this.map.addMarker(this.endmarker);
			// this.addReturnDepo(null);
		} else {
			this.endmarker = this.startmarker;
		}


		if (this.route.depo && this.dispatch.physicalstartlat && this.dispatch.physicalstartlng) {

			this.phisicalstartmarker = {
				id: 'phisicalStart',
				lat: this.dispatch.physicalstartlat,
				lng: this.dispatch.physicalstartlng,
				icon: Icons.PHYSICALSTART,
				highlightedicon: Icons.PHYSICALSTART,
				clickable: true
			};

			this.phisicalstartdistance = haversineDistance([this.phisicalstartmarker.lat, this.phisicalstartmarker.lng], [this.route.depo.lat, this.route.depo.lng]);
			this.map.addMarker(this.phisicalstartmarker);

		}

		if (this.dispatch.physicalstartlat && this.dispatch.physicalstartlng) {

			this.phisicalendmarker = {
				id: 'phisicalEnd',
				lat: this.dispatch.stoplat,
				lng: this.dispatch.stoplng,
				icon: Icons.PHYSICALEND,
				highlightedicon: Icons.PHYSICALEND,
				clickable: true
			};

			this.map.addMarker(this.phisicalendmarker);

		}



	}


	setupZoom() {
		if (this.map._markers.length === 1) {
			this.map.zoomToMarkers(null, 14, 14, false);
		} else {
			this.map.zoomToMarkers(null, null, null, true);
		}
	}

	addPolylines(deliveries: DispatchSegment[], color: string, prefix: string, weight: number, opacity: number) {
		this.logger.log('addPolylines', prefix, deliveries);

		if (deliveries && this.map) {

			for (let index = 0; index < deliveries.length; index++) {
				deliveries[index].decodePolyline();

				if (deliveries[index].todelid !== undefined) {
					if (this.segmentsVisibility[deliveries[index].todelid] === undefined) {
						this.segmentsVisibility[deliveries[index].todelid] = {};
					}

					if (this.segmentsPresence[deliveries[index].todelid] === undefined) {
						this.segmentsPresence[deliveries[index].todelid] = {};
					}

					this.segmentsVisibility[deliveries[index].todelid][prefix] = true;
					this.segmentsPresence[deliveries[index].todelid][prefix] = true;
				}
				this.returnsegment[prefix] = deliveries[deliveries.length - 1].polylineid;
				this.map.addPolyline(deliveries[index].polyline, color, prefix + deliveries[index].polylineid, weight, opacity);
			}
		}
	}



	removePolylines(deliveries: DispatchSegment[], prefix: string) {
		if (deliveries && this.map) {
			for (let index = 0; index < deliveries.length; index++) {
				deliveries[index].decodePolyline();

				this.map.removePolyline(prefix + deliveries[index].polylineid);
			}
		}
	}


	markerMoreInfo(marker: any) {
		this.moreinfomarker = marker;
	}

	closeMoreinfopanel() {
		this.moreinfomarker = undefined;
	}

	setAclFeatures() {
		if (this.dispatch) {

			if (this.aclService.hasPermission('dispatches.detail.route.reroutingpane')) {
				this.showpanel = true;
				this.routepanelacl = true;

			}

			if (this.aclService.hasPermission('dispatches.detail.route.livemappane')) {
				this.showmappane = true;

			}

			if (this.aclService.hasPermission('dispatches.detail.route.calcandsaveorder')) {
				this.showcalcsaveorder = true;

			}

			if (this.aclService.hasPermission('dispatches.detail.route.allowresetorder')) {
				this.showresetorder = true;

			}

			if (this.aclService.hasPermission('dispatches.detail.route.applyoptimized')) {
				this.showapplyoptimized = true;

			}

			if (this.aclService.hasPermission('dispatches.detail.route.applyoptimizedandsave')) {
				this.showapplyoptimizedandsave = true;

			}

		} else {
			if (this.aclService.hasPermission('routesimulation.reroutingpane')) {
				this.showpanel = true;
				this.routepanelacl = true;

			}
			if (this.aclService.hasPermission('routesimulation.mappane')) {
				this.showmappane = true;

			}

		}

	}


	onVehicleChange() {
		if (this.selectedVehicle) {
			this.route.vehicleid = this.selectedVehicle.id;
		}
	}

	onDriverChange() {
		if (this.selectedDriver) {
			this.route.driverid = this.selectedDriver.id;
		}
	}


	saveDispatch(saveBtn: HTMLButtonElement) {

		saveBtn.disabled = true;

		this.route.setLocids();

		const departureTime = new Date(this.route.departuredate).getTime();
		const timeNow = new Date().getTime();

		if (departureTime && (departureTime < timeNow)) {
			const messages = this.translateService.instant(['labels.future-departuretime', 'labels.dispatch']);
			this.messageService.sendWarn(messages['labels.future-departuretime'], messages['labels.dispatch']);
			return;
		}



		this.dispatchService.saveDraft(this.route).subscribe(
			(dispatch: Dispatch) => {
				if (dispatch && dispatch.id) {
					this.router.navigate([`dispatch/dispatches/${dispatch.id}`]);
				}

				saveBtn.disabled = false;
			}, ({ error }) => {
				saveBtn.disabled = false;
				if (this.isCommercial) {
					this.messageService.sendError(error, this.translateService.instant('labels.dispatch'));
					return;
				}




				this.messageService.sendError(error);
			});
	}

	output(waypoint) {
		console.log('%c waypoint', 'color:#FFB86C', waypoint);

	}

}


